(function () {
  class TrailContainer extends PIXI.Container {
    constructor() {
      super();

      const self = this;
      this.trailAssetsX4 = [];
      this.trailAssetsX3 = [];
      this.trailNumX4 = 4;
      this.trailNumX3 = 3;
      this.textOffDelay = 0;
      this.currentModifier = null;
      this.trailToRestart = false;

      StateMachine.Create(this);

      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("START_X4_TRAIL_ANIMATION", function () {
        self.updateX4TrailCount();
      });
      this.stateMachine.addState("SHOW_MODIFIER_TEXT_ANIMATION", function () {
        self.updateShowModifierText();
      });
      this.stateMachine.addState("START_X3_TRAIL_ANIMATION", function () {
        self.updateX3TrailCount();
      });
      this.stateMachine.addState("RESET_TRAIL_ANIMATION", function () {
        self.reset_trailCount();
      });
    }

    initialise() {
      this.gameController = resourceManager.getController("gameController");
      const self = this;
      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.trailX4 = resourceManager.get(
        `trail:TrailContainer:trailContainerX4`
      );
      this.trailX3 = resourceManager.get(
        `trail:TrailContainer:trailContainerX3`
      );
      this.trailX3.visible = false;
      this.trailX4.visible = true;

      this.doubleWildText = resourceManager.get(
        "trail:TrailContainer:DoubleWildText"
      );
      this.doubleWildText.visible = false;

      this.wildStackText = resourceManager.get(
        "trail:TrailContainer:WildStackText"
      );
      this.wildStackText.visible = false;

      this.multiBoostText = resourceManager.get(
        "trail:TrailContainer:MultiBoostText"
      );
      this.multiBoostText.visible = false;

      this.extraLifeText = resourceManager.get(
        "trail:TrailContainer:ExtraLifeText"
      );
      this.extraLifeText.visible = false;

      this.fullGem = resourceManager.get(`trail:TrailContainer:topGemFull`);
      this.fullGemGlow = resourceManager.get(`trail:TrailContainer:topGemGlow`);
      this.fullGemMask = resourceManager.get(`trail:TrailContainer:topGemMask`);
      this.swipeShine = resourceManager.get(`trail:TrailContainer:swipeShine`);
      this.swipeShineMask = resourceManager.get(
        `trail:TrailContainer:swipeShineMask`
      );

      this.fullGemMask.beginFill(0xffffff);
      this.fullGemMask.lineStyle(0, 0xffffff);
      this.fullGemMask.drawRect(0, 0, this.fullGem.width, this.fullGem.height);

      this.fullGemMask.pivot.x = this.fullGemMask.width;
      this.fullGemMask.pivot.y = this.fullGemMask.height / 2;
      this.fullGemMask.scale.x = 0;

      this.fullGem.mask = this.fullGemMask;
      this.fullGemGlow.mask = this.fullGemMask;

      var width = 30;

      this.swipeShine.beginFill(0xffffff);
      this.swipeShine.lineStyle(0, 0xffffff);
      this.swipeShine.drawRect(0, 0, width, this.fullGem.height * 2);
      this.swipeShine.pivot.x = width / 2;
      this.swipeShine.pivot.y = this.fullGem.height;
      this.swipeShine.rotation = Math.PI / 10;
      this.swipeShine.visible = false;
      this.swipeShine.alpha = 0.5;
      this.swipeShine.mask = this.swipeShineMask;

      //Set up trails asset array
      for (let trailX4Idx = 0; trailX4Idx < this.trailNumX4; trailX4Idx++) {
        let trailRock = resourceManager.get(
          `trail:TrailContainer:trailContainerX4:trailPart${trailX4Idx}:off`
        );
        let trailGem = resourceManager.get(
          `trail:TrailContainer:trailContainerX4:trailPart${trailX4Idx}:on`
        );
        let trailAnim = resourceManager.get(
          `trail:TrailContainer:trailContainerX4:trailPart${trailX4Idx}:trailAnim`
        );
        this.trailAssetsX4.push({
          trailRock: trailRock,
          trailGem: trailGem,
          trailAnim: trailAnim,
          trailActivated: false,
        });
      }

      for (let trailX3Idx = 0; trailX3Idx < this.trailNumX3; trailX3Idx++) {
        let trailRock = resourceManager.get(
          `trail:TrailContainer:trailContainerX3:trailPart${trailX3Idx}:off`
        );
        let trailGem = resourceManager.get(
          `trail:TrailContainer:trailContainerX3:trailPart${trailX3Idx}:on`
        );
        let trailAnim = resourceManager.get(
          `trail:TrailContainer:trailContainerX3:trailPart${trailX3Idx}:trailAnim`
        );
        this.trailAssetsX3.push({
          trailRock: trailRock,
          trailGem: trailGem,
          trailAnim: trailAnim,
          trailActivated: false,
        });

        this.createTweens();
      }
    }

    createTweens() {
      let textScaleIn = 0;
      let baseScale = 0.95;

      var fadeDuration = 0.2;
      var showDuration = 1;

      let rocks = [];
      let gems = [];

      this.trailAssetsX3.forEach((asset) => {
        rocks.push(asset.trailRock);
        gems.push(asset.trailGem);
      });

      this.flashLuckyTrailTimeline = gsap.timeline({ paused: true }).to(rocks, {
        duration: 0.06,
        alpha: 0,
        repeat: 3,
        ease: "power2.out",
        yoyo: true,
        repeatDelay: 0.05,
      });

      this.showFullGem = gsap
        .timeline({ paused: true })
        .call(() => {
          this.fullGem.alpha = 1;
          this.fullGemGlow.alpha = 1;
          this.fullGemMask.scale.x = 0;
        })
        .to(this.fullGemMask.scale, {
          duration: 0.5,
          ease: "power1.in",
          x: 1,
        })
        .call(() => {
          this.stateMachine.switchState("SHOW_MODIFIER_TEXT_ANIMATION");
        });

      let hideFullGem = gsap.to([this.fullGem, this.fullGemGlow], {
        duration: fadeDuration,
        alpha: 0,
      });

      let doubleWildTextTweenOff = gsap.to(this.doubleWildText, {
        alpha: 0,
        duration: fadeDuration,
        paused: true,
        onStart: () => {
          hideFullGem.restart(true).time(0);
        },
        onComplete: () => {
          this.doubleWildText.visible = false;
          if (this.trailToRestart) {
            this.trailToRestart = false;
            if (!gameController.extraLifeUsed) {
              this.startTrailAnim();
            } else {
              gameController.extraLifeUsed = false;
            }
          }
        },
      });

      let doubleWildTextTweenOn = gsap.fromTo(
        this.doubleWildText.scale,
        {
          x: textScaleIn,
          y: textScaleIn,
        },
        {
          x: baseScale,
          y: baseScale,
          duration: showDuration,
          ease: Bounce.easeOut,
          paused: true,
          onStart: () => {
            this.doubleWildText.visible = true;
            this.doubleWildText.alpha = 1;
          },
        }
      );

      let wildStackTextTweenOn = gsap.fromTo(
        this.wildStackText.scale,
        {
          x: textScaleIn,
          y: textScaleIn,
        },
        {
          delay: 0.5,
          x: baseScale,
          y: baseScale,
          duration: showDuration,
          ease: Bounce.easeOut,
          paused: true,
          onStart: () => {
            this.wildStackText.visible = true;
            this.wildStackText.alpha = 1;
          },
        }
      );

      let wildStackTextTweenOff = gsap.to(this.wildStackText, {
        alpha: 0,
        duration: 0.3,
        paused: true,
        onStart: () => {
          hideFullGem.restart(true).time(0);
        },
        onComplete: () => {
          this.wildStackText.visible = false;
          if (this.trailToRestart) {
            this.trailToRestart = false;
            if (!gameController.extraLifeUsed) {
              this.startTrailAnim();
            } else {
              gameController.extraLifeUsed = false;
            }
          }
        },
      });

      let multiplierBoostTextTweenOff = gsap.to(this.multiBoostText, {
        alpha: 0,
        duration: 0.3,
        paused: true,
        onStart: () => {
          hideFullGem.restart(true).time(0);
        },
        onComplete: () => {
          if (this.trailToRestart) {
            this.trailToRestart = false;
            if (!gameController.extraLifeUsed) {
              this.startTrailAnim();
            } else {
              gameController.extraLifeUsed = false;
            }
          }
          this.multiBoostText.visible = false;
        },
      });

      let multiplierBoostTextTweenOn = gsap.fromTo(
        this.multiBoostText.scale,
        {
          x: textScaleIn,
          y: textScaleIn,
        },
        {
          x: baseScale,
          y: baseScale,
          duration: showDuration,
          ease: Bounce.easeOut,
          paused: true,
          onStart: () => {
            this.multiBoostText.visible = true;
            this.multiBoostText.alpha = 1;
          },
        }
      );

      let extraLifeTextTweenOff = gsap.to(this.extraLifeText, {
        alpha: 0,
        duration: 0.3,
        paused: true,
        onStart: () => {
          hideFullGem.restart(true).time(0);
        },
        onComplete: () => {
          this.extraLifeText.visible = false;
          if (this.trailToRestart) {
            this.trailToRestart = false;
            if (!gameController.extraLifeUsed) {
              this.startTrailAnim();
            } else {
              gameController.extraLifeUsed = false;
            }
          }
        },
      });

      let extraLifeTextTweenOn = gsap.fromTo(
        this.extraLifeText.scale,
        {
          x: textScaleIn,
          y: textScaleIn,
        },
        {
          delay: 0.5,
          x: baseScale,
          y: baseScale,
          duration: showDuration,
          ease: Bounce.easeOut,
          paused: true,
          onStart: () => {
            this.extraLifeText.visible = true;
            this.extraLifeText.alpha = 1;
          },
          onComplete: () => {
            messageBus.post("ExtraLife:showAnimation");
          },
        }
      );

      this.awardTextTweens = {
        DoubleWildTextTweenOn: doubleWildTextTweenOn,
        DoubleWildTextTweenOff: doubleWildTextTweenOff,
        WildStackTextTweenOn: wildStackTextTweenOn,
        WildStackTextTweenOff: wildStackTextTweenOff,
        MultiplierBoostTextTweenOn: multiplierBoostTextTweenOn,
        MultiplierBoostTextTweenOff: multiplierBoostTextTweenOff,
        ExtraLifeTextTweenOn: extraLifeTextTweenOn,
        ExtraLifeTextTweenOff: extraLifeTextTweenOff,
      };
    }

    flashLuckyTrail() {
      this.flashLuckyTrailTimeline.play(0);
    }

    animateTrail(modifier, trailCount) {
      if (gameController.extraLifeUsed) {
        if (this.currentModifier !== null) {
          this.trailToRestart = true;
          this.currentTrailNum = 0;
          this.trailRunEnded();
        } else {
          gameController.extraLifeUsed = false;
        }
        //NOT TO UPDATE TRAIL
      } else {
        if (this.currentModifier !== null) {
          this.trailToRestart = true;
          this.currentTrailNum = 0;
          this.trailRunEnded();
        } else {
          if (trailCount === 0) {
            //0 means bonus has been activated or it means that a trail is not to be updated because an extra life has been used
            if (modifier) {
              this.currentModifier = modifier.type;
            }

            this.currentTrailNum++;
            this.startTrailAnim();
          } else {
            this.currentTrailNum = trailCount - 1;
            this.startTrailAnim();
          }
        }
      }
    }

    startTrailAnim() {
      if (
        this.currentModifier !== "ExtraLive" &&
        gameController.extraLiveActive === false
      ) {
        if (freespins.inFreespins || gameData.encoreEnabled) {
          this.stateMachine.switchState("START_X3_TRAIL_ANIMATION");
        } else {
          this.stateMachine.switchState("START_X4_TRAIL_ANIMATION");
        }
      }
    }

    switchTrail(trailType) {
      if (trailType === "trailX3") {
        this.trailX3.visible = true;
        this.trailX4.visible = false;
      } else {
        this.trailX3.visible = false;
        this.trailX4.visible = true;
      }
    }

    updateX4TrailCount() {
      var trail = this.trailAssetsX4[this.currentTrailNum];

      if (this.phase.enter()) {
        trail.trailRock.visible = false;
        trail.trailAnim.gotoAndPlay(0);
        trail.trailActivated = true;

        soundManager.play("trailIncrease");

        if (this.currentModifier) {
          resourceManager
            .get(
              `trail:TrailContainer:trailContainerX4:trailPart3:trailGemSparks`
            )
            .gotoAndPlay(0);
        }
      }

      if (this.phase.timed(500)) {
      }

      if (this.phase.once()) {
        this.animateSwipeShine(
          resourceManager.get(
            `trail:TrailContainer:trailContainerX4:trailPart${this.currentTrailNum}`
          ).x,
          1
        );
      }

      if (this.phase.timed(1000)) {
      }

      if (this.phase.once()) {
        if (this.currentModifier) {
          this.animateGreenFullGem();
        }
      }
    }

    updateX3TrailCount() {
      var trail = this.trailAssetsX3[this.currentTrailNum];

      if (this.phase.enter()) {
        trail.trailRock.visible = false;
        trail.trailAnim.gotoAndPlay(0);
        trail.trailActivated = true;

        soundManager.play("trailIncrease");

        if (this.currentModifier) {
          resourceManager
            .get(
              `trail:TrailContainer:trailContainerX3:trailPart2:trailGemSparks`
            )
            .gotoAndPlay(0);
        }
      }

      if (this.phase.timed(500)) {
      }

      if (this.phase.once()) {
        this.animateSwipeShine(
          resourceManager.get(
            `trail:TrailContainer:trailContainerX3:trailPart${this.currentTrailNum}`
          ).x,
          1.34
        );
      }

      if (this.phase.timed(1000)) {
      }

      if (this.phase.once()) {
        if (this.currentModifier) {
          this.animateGreenFullGem();
        }
      }
    }

    animateSwipeShine(xPos, scale) {
      this.swipeShineMask.scale.x = scale;
      this.swipeShineMask.scale.y = scale;

      var width = this.swipeShineMask.width;

      this.swipeShineMask.x = xPos;
      this.swipeShine.x = xPos - width;
      this.swipeShine.visible = true;

      var targetX = xPos + width;

      gsap.to(this.swipeShine, {
        duration: 1,
        x: targetX,
        onComplete: () => {
          this.swipeShine.visible = false;
        },
      });
    }

    animateGreenFullGem() {
      this.showFullGem.play(0);
      soundManager.play("trailComplete");
    }

    animateTextSparks() {
      resourceManager.get(`trail:TrailContainer:textGemSparks`).gotoAndPlay(0);
    }

    updateShowModifierText() {
      if (this.phase.enter()) {
        if (this.currentModifier === "MultiplierBoost") {
          messageBus.post("Game:boostMulti");
        }

        if (this.currentModifier !== null) {
          this.animateTextSparks();
          let modTweenName = `${this.currentModifier}TextTweenOn`;
          this.awardTextTweens[modTweenName].restart(true).time(0);
        }
      }
    }

    removeCurrentModifierAssets(delay) {
      if (this.currentModifier !== null) {
        let modTweenName = `${this.currentModifier}TextTweenOff`;
        this.awardTextTweens[modTweenName].restart(true).time(0).delay(delay);
      }
    }

    hideTrail() {
      this.visible = false;
    }

    showTrail() {
      this.visible = true;
    }

    resetTrail() {
      if (freespins.inFreespins || gameData.encoreEnabled) {
        for (let trailIdx = 0; trailIdx < this.trailNumX3; trailIdx++) {
          var trail = this.trailAssetsX3[trailIdx];

          if (trail.trailActivated === true) {
            trail.trailRock.visible = true;
            trail.trailActivated = false;
          }
        }
      } else {
        for (let trailIdx = 0; trailIdx < this.trailNumX4; trailIdx++) {
          var trail = this.trailAssetsX4[trailIdx];

          if (trail.trailActivated === true) {
            trail.trailRock.visible = true;
            trail.trailActivated = false;
          }
        }
      }
    }

    //Spin ended no winning cascade drop
    trailRunEnded() {
      this.resetTrail();

      if (this.currentModifier != null) {
        this.removeCurrentModifierAssets();
        this.currentModifier = null;
      }

      this.showTrail();
    }

    trailRunEndedFS() {
      if (this.currentModifier != null) {
        this.resetTrail();
        this.removeCurrentModifierAssets();
        this.currentModifier = null;
      }

      this.showTrail();
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }
  }

  create = function (json) {
    return new TrailContainer();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ["", ""];
  };

  resourceManager.registerObjectType(
    "TrailContainer",
    create,
    initialise,
    getFilesRequired
  );
})();
